module.exports = __webpack_public_path__ + "img/bj_wu@2x.8c3879e9.png";